import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing4,
  spacing8,
  spacing16,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import { grey10, grey5, grey7 } from 'approot/shared/styles/colours.style';
import { borderRadius16 } from 'approot/shared/styles/borders.style';
import {
  fontSize16LineHeight,
  PStyled,
  Heading18,
} from 'approot/shared/styles/typography.style';

export const GuidedResearchAddLink = styled.div`
  display: flex;

  svg {
    margin-right: ${rem(spacing8)};
    fill: none;
    stroke: ${grey10};
  }
`;

export const GuidedResearchLink = styled.div`
  border: 1px solid ${grey5};
  border-radius: ${rem(borderRadius16)};
  padding: ${rem(spacing16)};
  margin-bottom: ${rem(spacing24)};
`;

type GuidedResearchDisplayWrapperProps = {
  $hide?: boolean;
};

export const GuidedResearchDisplayWrapper = styled.div<GuidedResearchDisplayWrapperProps>`
  display: ${({ $hide }) => ($hide ? 'none' : 'block')};
`;

export const GuidedResearchLinkHeader = styled.div`
  display: flex;
  justify-content: space-between;
  min-height: ${rem(50)};

  & > div {
    overflow: hidden;
  }
`;

export const GuidedResearchRichtext = styled(PStyled)`
  color: ${grey7};
  margin-bottom: ${rem(spacing8)};
  overflow: hidden;
  max-height: ${rem(fontSize16LineHeight * 2)};

  p,
  ul,
  ol {
    margin-bottom: 0;
  }
`;

export const GuidedResearchText = styled(PStyled).attrs({
  marginBottom: 0,
})`
  line-height: ${rem(fontSize16LineHeight)};
`;

export const GuidedResearchHeading = styled(Heading18).attrs({
  marginBottom: spacing4,
  $fontWeight: 'medium',
  as: 'h2',
})``;
